import React from "react";
import AdminModulePage from "../../../components/Admin/ModulePage/AdminModulePage";

const AccountsPayable = () => {
    return <AdminModulePage moduleKey="accounts-payable" />;
};

export default AccountsPayable;
